import { LotAttributes } from "../../products"

export type DeliveryItemRow = {
    itemId: string
    productId: string
    lotId?: string
    pending: number
    quantity: number
    lotData?: DeliveryItemLotData
}

export type DeliveryItemLotData = {
    lotCode?: string
    lotId?: string
    lotAttributes?: LotAttributes
}

export type CompleteShipmentItemRow = {
    itemId: string
    productId: string
    lotId?: string
    dispatched: number
    deliveredQuantity: number
    notDeliveredQuantity: number
}

export type ReturnItemRow = {
    itemId: string
    productId: string
    lotId?: string
    delivered: number
    returnQuantity: number
    defectiveQuantity: number
    nonDefectiveQuantity: number
}

export type CancelItemRow = {
    itemId: string
    productId: string
    lotId?: string
    pending: number
    cancelQuantity: number
}

export enum NoteGenerationType {
    ADJUSTMENT_NOTE = 'AdjustmentNote',
    CREDIT_NOTE = 'CreditNote'
}

export const INVOICE_IN_FLIGHT_MESSAGE = 'Hay una factura pendiente de autorización. Esperá a que termine para continuar.'
